<template>
  <div>
    <div class="overflow-hidden">
      <div class="float-left" style="width: 128px; overflow-y: auto">
        <div class="pt-6" style="min-height: calc(100vh - 135px)">
          <Menu :selectedKeys="[3]"></Menu>
        </div>
      </div>
      <div class="float-right" style="width: calc(100% - 128px)">
        <div class="p-6 pb-0" v-if="info.status_id > 0">
          <a-alert
            v-if="info.status_id == 1"
            message="审核中"
            class="w-1/2"
            type="warning"
            show-icon
          />
          <a-alert
            v-if="info.status_id == 3"
            message="驳回意见"
            class="w-1/2"
            :description="info.review_reason"
            type="error"
            show-icon
          />
          <a-alert
            v-if="info.status_id == 2"
            message="认证成功"
            class="w-1/2"
            type="success"
            show-icon
          />
        </div>
        <a-anchor :offsetTop="64">
          <div class="p-6 bg-white border-b border-gray-200 border-solid">
            <a-button type="primary" v-if="disabled" @click="disabled = false" icon="form">
              {{ info.status_id == 2 ? '修改企业认证' : '修改' }}</a-button
            >
            <div v-else>
              <a-button v-if="info.id > 0" type="default" @click="cancel" class="mr-4" icon="undo"
                >取消修改</a-button
              >
              <a-button type="primary" @click="submit" icon="save" :loading="btnLoading">
                提交</a-button
              >
            </div>
          </div>
        </a-anchor>
        <a-spin :spinning="spinning">
          <div :style="{ width: '500px' }" class="pt-6">
            <a-form :form="form" v-bind="formItemLayout">
              <a-form-item label="营业执照">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'license',
                      {
                        rules: [{ required: !disabled, message: '请上传营业执照' }],
                      },
                    ]"
                  ></a-input>
                  <Upload :disabled="disabled" :src="info.license" @upload="licenseUpload"></Upload>
                </div>
              </a-form-item>
              <a-form-item label="开户许可证">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'certificate_src',
                      {
                        rules: [{ required: !disabled, message: '请上传开户许可证' }],
                      },
                    ]"
                  ></a-input>
                  <Upload
                    :disabled="disabled"
                    :src="info.certificate_src"
                    @upload="certUpload"
                  ></Upload>
                </div>
              </a-form-item>
              <a-form-item label="资质证书">
                <div class="overflow-hidden">
                  <a-input v-show="false" v-decorator="['qualification_src']"></a-input>
                  <Upload
                    :disabled="disabled"
                    :src="info.qualification_src"
                    @upload="qUpload"
                  ></Upload>
                </div>
              </a-form-item>
              <a-form-item label="企业名称">
                <a-textarea
                  v-decorator="[
                    'owner',
                    { rules: [{ required: !disabled, message: '请输入企业名称' }] },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="社会信用代码">
                <a-textarea
                  v-decorator="[
                    'taxNumber',
                    {
                      rules: [{ required: !disabled, message: '请输入社会信用代码' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea> </a-form-item
              ><a-form-item label="法人代表">
                <a-textarea
                  v-decorator="[
                    'legal_person',
                    { rules: [{ required: !disabled, message: '请输入法人代表' }] },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="地址">
                <a-textarea
                  v-decorator="[
                    'address',
                    { rules: [{ required: !disabled, message: '请输入地址' }] },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="开户行">
                <a-textarea
                  v-decorator="[
                    'bankName',
                    { rules: [{ required: !disabled, message: '请输入开户行' }] },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="开户企业名称">
                <a-textarea
                  v-decorator="[
                    'name',
                    {
                      rules: [{ required: !disabled, message: '请输入开户企业名称' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="开户行账号">
                <a-textarea
                  v-decorator="[
                    'bankAccount',
                    {
                      rules: [{ required: !disabled, message: '请输入开户行账号' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="电话">
                <a-textarea :disabled="disabled" v-decorator="['tel']" autoSize></a-textarea>
              </a-form-item>
              <a-form-item label="联系人电话">
                <a-textarea
                  :disabled="disabled"
                  v-decorator="['contact_tel']"
                  autoSize
                ></a-textarea>
              </a-form-item>
            </a-form>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>
<script>
  import Upload from '@/components/Upload/index';
  import Menu from '@/views/admin/menu/index.vue';
  import { licenseocr, cert_ocr, companySave } from '@/api/company';
  import { user_company } from '@/api/user';
  import { pick } from 'lodash';
  export default {
    components: { Menu, Upload },
    data() {
      return {
        info: {},
        disabled: false,
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        form: this.$form.createForm(this, { name: 'company' }),
        spinning: false,
        btnLoading: false,
      };
    },
    activated() {
      this.getInfo();
    },
    watch: {
      info(a) {
        if (a.id) {
          let info = Object.assign({}, a, { name: a.owner });
          // console.log(info);
          setTimeout(() => {
            this.form.setFieldsValue(info);
          }, 10);
          this.disabled = true;
        } else {
          this.disabled = false;
          setTimeout(() => {
            this.form.resetFields();
          }, 10);
        }
      },
    },
    methods: {
      async getInfo() {
        this.spinning = true;
        this.info = (await user_company()) || {};
        this.spinning = false;
      },
      async licenseUpload(res) {
        // console.log(res);
        try {
          setTimeout(() => this.form.setFieldsValue({ license: res.pathname }), 1);
          let ocrres = await licenseocr(res.id);
          let ocrrespick = pick(ocrres, ['address', 'taxNumber', 'owner', 'legal_person']);
          setTimeout(() => this.form.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async certUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ certificate_src: res.pathname }), 1);
          let ocrres = await cert_ocr(res.id);

          let ocrrespick = pick(ocrres, ['bankAccount', 'bankName']);
          ocrrespick.name = ocrres.owner;
          setTimeout(() => this.form.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      qUpload(res) {
        setTimeout(() => this.form.setFieldsValue({ qualification_src: res.pathname }), 1);
        this.info.qualification_src = res.pathname;
      },
      async submit(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            if (values.name != values.owner) {
              this.$message.warning('开户许可证和营业执照不匹配,请重新上传');
              return;
            }
            try {
              this.spinning = true;
              this.btnLoading = true;
              let data = Object.assign(this.info, values);
              data.is_self = true;
              await companySave(data);
              this.$store.dispatch('user/getUserInfoAction');
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.getInfo();
              this.spinning = false;
              this.btnLoading = false;
            }
          } else {
            console.log(values);
          }
        });
      },
      async cancel() {
        await this.getInfo();
        this.disabled = true;
      },
    },
  };
</script>
